import SET from '../../combosDrawsTemplate/settings'
import { getSameAction, sortBetSize } from '../../helpers/helpers'
import { constants, tabNames } from '../../Viewer/viewModeConstants'

export const MAP_CARD = createArray(52, 52)
const handCards = Array.from(Array(1326), () => [])
mapCards()

export function mapCards() {
	let countCard = 0
	for (let i = 0; i < 52; i++) {
		for (let j = i + 1; j < 52; j++) {
			handCards[countCard][0] = i
			handCards[countCard][1] = j
			MAP_CARD[j][i] = countCard
			MAP_CARD[i][j] = countCard++
		}
	}
}

export const getRangeStruct = ({ combos, draws, abs, eq, ev, prob, eqr = null }) => {
	const rValues = []

	for (let i = 0; i < 13; i++) {
		for (let j = 0; j < 13; j++) {
			let countHand = 0
			const val = 0.0
			const cArr = []

			for (let s1 = 0; s1 < 4; s1++) {
				for (let s2 = 0; s2 < 4; s2++) {
					if (i === j && s1 >= s2) {
						continue
					}
					if (i < j && s1 === s2) {
						continue
					}
					if (i > j && s1 !== s2) {
						continue
					}
					const card1 = (12 - i) * 4 + s1
					const card2 = (12 - j) * 4 + s2
					let hand = 0
					let cStr = ''

					if (card1 < card2) {
						hand = MAP_CARD[card2][card1]
						cStr = cardToStr(card2) + cardToStr(card1)
					} else {
						hand = MAP_CARD[card1][card2]
						cStr = cardToStr(card1) + cardToStr(card2)
					}

					if (combos[hand] < 0) {
						continue
					}

					countHand++
					const c = {}
					c.s = cStr
					c.com = combos[hand]
					c.draw = draws ? draws[hand] : null
					c.abs = abs[hand]
					c.eq = eq ? eq[hand] : null
					c.ev = ev ? ev[hand] : null
					c.index = hand
					c.prob = prob ? prob[hand] : null
					c.eqr = eqr ? eqr[hand] : null
					cArr.push(c)
				}
			}

			const obj = {}
			obj.p = val / countHand
			obj.c = cArr

			rValues.push(obj)
		}
	}

	return rValues
}

/**
 * @param strategy {any[]} - Array of actions to each stack
 * @param actionsOrder {string[]} - array with order of actions
 * @return biggestActionArray - an array of all available actions from all stacks
 */
export const getReducedArrBiggestAction = (strategy, actionsOrder) => {
	if (strategy.length > 0) {
		// find stack with Max count of actions
		const biggestActions = strategy.reduce((acc, current) => {
			if (!acc) {
				return current
			}

			if (!current) {
				return acc
			}

			if (acc.length >= current.length) {
				return acc
			}

			return current
		})

		const allActions = biggestActions.slice()
		const maxRaiseIndex = Math.max(...allActions.map((item) => (item.raiseIndex > -1 ? item.raiseIndex : -1)))
		const minRaiseIndex = Math.min(...allActions.map((item) => (item.raiseIndex > -1 ? item.raiseIndex : 0)))

		strategy.map((stack) =>
			stack.map((action) => {
				let sameAction = allActions.find((item) => getSameAction(item, action))

				if (!sameAction) {
					let indexToInsertAction = 0

					if (action.action.startsWith('F') || action.action.startsWith('C')) {
						// insert Call, Fold, Check
						let leftNeighborIndex = actionsOrder.indexOf(action.action.slice(0, 1)) - 1

						if (leftNeighborIndex > -1) {
							let neighbor = actionsOrder[leftNeighborIndex]

							if (neighbor === 'C' || neighbor === 'F') {
								indexToInsertAction = allActions.findIndex((item) => item.action.startsWith(neighbor)) + 1
							}

							if (neighbor === 'R') {
								let rI = actionsOrder.indexOf('A') > actionsOrder.indexOf('R') ? maxRaiseIndex : minRaiseIndex

								indexToInsertAction = allActions.findIndex((item) => item.raiseIndex === rI) + 1
							}

							if (neighbor === 'A') {
								indexToInsertAction = allActions.findIndex((item) => item.isAllIn) + 1
							}
						}
					}

					if ((action.action.startsWith('R') || action.action.startsWith('B')) && !action.isAllIn) {
						const sideToInsert = actionsOrder.indexOf('A') > actionsOrder.indexOf('R')
						const maxRaiseIndexAction = allActions.findIndex((item) => item.raiseIndex === maxRaiseIndex)

						if (sideToInsert) {
							indexToInsertAction = maxRaiseIndexAction + 1
						} else {
							indexToInsertAction = maxRaiseIndexAction - 1
						}
					}

					if (action.isAllIn) {
						// insert All in
						let aName = 'A'
						let leftNeighborIndex = actionsOrder.indexOf(aName) - 1

						if (leftNeighborIndex > -1) {
							let neighbor = actionsOrder[leftNeighborIndex]

							if (neighbor === 'C' || neighbor === 'F') {
								indexToInsertAction = allActions.findIndex((item) => item.action.startsWith(neighbor)) + 1
							}

							if (neighbor === 'R') {
								indexToInsertAction = allActions.findIndex((item) => item.raiseIndex === maxRaiseIndex) + 1
							}
						}
					}

					allActions.splice(indexToInsertAction, 0, action)
				}
			})
		)

		return allActions
	}
}

export function getActionStruct(data, threshold) {
	const ACTION_STRUCT = []
	const raiseIndex = []

	for (let i = 0; i < data.actions.length; i++) {
		if (
			(data.actions[i].action.includes('Bet') || data.actions[i].action.includes('Raise')) &&
			!data.actions[i].is_allin
		) {
			raiseIndex.push(data.actions[i].action)
		}
	}

	raiseIndex.sort((a, b) => sortBetSize(a, b))

	for (let actionIndex = 0; actionIndex < data.actions.length; actionIndex++) {
		const rValues = []
		const values = data.actions[actionIndex].played
		const evs = data.actions[actionIndex].ev
		const { combos, draw, abs, equity } = data
		const mainEv = data.main_ev
		const mainEqr = data.main_eqr

		for (let i = 0; i < 13; i++) {
			for (let j = 0; j < 13; j++) {
				let countHand = 0
				let val = 0.0
				const cArr = []

				for (let s1 = 0; s1 < 4; s1++) {
					for (let s2 = 0; s2 < 4; s2++) {
						if (i === j && s1 >= s2) {
							continue
						}
						if (i < j && s1 === s2) {
							continue
						}
						if (i > j && s1 !== s2) {
							continue
						}
						const card1 = (12 - i) * 4 + s1
						const card2 = (12 - j) * 4 + s2
						let hand = 0
						let cStr = ''

						if (card1 < card2) {
							hand = MAP_CARD[card2][card1]
							cStr = cardToStr(card2) + cardToStr(card1)
						} else {
							hand = MAP_CARD[card1][card2]
							cStr = cardToStr(card1) + cardToStr(card2)
						}

						if (values[hand] === -1 || combos[hand] < 0 || abs[hand] < threshold) {
							continue
						}

						val += values[hand]
						countHand++
						const c = {}
						c.s = cStr
						c.val = values[hand]
						c.ev = evs[hand]
						c.com = combos[hand]
						c.draw = draw[hand]
						c.abs = abs[hand]
						c.eq = equity[hand]
						c.index = hand
						c.mainEv = mainEv ? mainEv[hand] : null
						c.eqr = mainEqr ? mainEqr[hand] : null
						cArr.push(c)
					}
				}
				const obj = {}
				obj.p = val / countHand
				obj.c = cArr

				rValues.push(obj)
			}
		}

		ACTION_STRUCT.push({
			action: data.actions[actionIndex].action,
			isAllIn: data.actions[actionIndex].is_allin,
			id: actionIndex,
			raiseIndex: raiseIndex.indexOf(data.actions[actionIndex].action),
			stack: data.stack,
			position: data.player,
			rakeOpenName: data.rake_open_name,
			values: rValues,
			gto_range: data.actions[actionIndex].gto_range,
		})
	}

	return ACTION_STRUCT
}

export function createArray(length) {
	const arr = new Array(length || 0)
	let i = length

	if (arguments.length > 1) {
		const args = Array.prototype.slice.call(arguments, 1)
		while (i--) {
			arr[length - 1 - i] = createArray.apply(this, args)
		}
	}

	return arr
}

// get available combinations and draws
export function getInitComboDraw(data, threshold) {
	const comboSet = new Set()
	const drawSet = new Set()

	// get combos
	for (let i = 0; i < data.combos.length; i++) {
		if (data.combos[i] < 0 || data.abs[i] < threshold) {
			continue
		}
		comboSet.add(data.combos[i])
	}

	// get draws
	for (let i = 0; i < data.draw.length; i++) {
		if (data.draw[i] < 0 || data.abs[i] < threshold) {
			continue
		}
		drawSet.add(data.draw[i])
	}

	return { comboSet: Array.from(comboSet), drawSet: Array.from(drawSet) }
}

// get available combinations and draws
export function getInitComboDrawRange(data, threshold) {
	const comboSet = new Set()
	const drawSet = new Set()

	// get combos
	for (let i = 0; i < data.combos.length; i++) {
		if (data.combos[i] < 0 || (data.abs[i] < threshold && data.villain_abs[i] < threshold)) {
			continue
		}
		comboSet.add(data.combos[i])
	}

	// get draws
	for (let i = 0; i < data.draw.length; i++) {
		if (data.draw[i] < 0 || (data.abs[i] < threshold && data.villain_abs[i] < threshold)) {
			continue
		}
		drawSet.add(data.draw[i])
	}

	return { comboSet: Array.from(comboSet), drawSet: Array.from(drawSet) }
}

export function cardToStr(card) {
	if (card < 0 || card > 52) {
		return ''
	}
	const rank = Math.floor(card / 4)
	const suit = card % 4

	return SET.RANKS[12 - rank] + SET.SUITS[suit]
}

export const getUniqCombosAndDraws = (data, threshold) => {
	const combosForAllStacks = []
	const drawsForAllStacks = []

	data
		.slice()
		.sort((a, b) => b.stack - a.stack)
		.map((item) => {
			const { comboSet, drawSet } = getInitComboDraw(item, threshold)
			combosForAllStacks.push(comboSet)
			drawsForAllStacks.push(drawSet)
		})

	const uniqCombos = Array.from(new Set([...combosForAllStacks.flat()]))
	const uniqDraws = Array.from(new Set([...drawsForAllStacks.flat()]))

	return [uniqCombos, uniqDraws]
}

export function getKeyByValue(object, value) {
	return Object.keys(object).find((key) => object[key] === value)
}

export function getReportName(viewMode, { viewModeOnePlayer, viewModeTwoPlayers, reportsType }) {
	if (viewMode === constants.ONE_PLAYER) {
		return tabNames[getKeyByValue(constants, viewModeOnePlayer)]
	}
	if (viewMode === constants.TWO_PLAYER) {
		return tabNames[getKeyByValue(constants, viewModeTwoPlayers)]
	}
	if (viewMode === constants.GRAPHICS) {
		return tabNames[getKeyByValue(constants, reportsType)]
	}
}

export const getCurrentReport = (viewMode, { viewModeOnePlayer, viewModeTwoPlayers, reportsType }) => {
	if (viewMode === constants.ONE_PLAYER) {
		return viewModeOnePlayer
	}

	if (viewMode === constants.TWO_PLAYER) {
		return viewModeTwoPlayers
	}

	if (viewMode === constants.GRAPHICS) {
		return reportsType
	}
}

export const getActionProbability = (actions, heroMainAbs, globalBoard, query) => {
	const board = query.includes('_F.')
		? globalBoard.slice(0, 3)
		: query.includes('_T.')
		? globalBoard.slice(0, 4)
		: globalBoard.slice(0, 5)

	return actions.map((action) => {
		if (!action.is_equity) {
			return action
		}

		const heroProb = []
		const villainProb = []

		const cardsHero = Array.from(Array(52), () => 0)
		const cardsVillain = Array.from(Array(52), () => 0)

		let villainSum = 0
		let heroSum = 0
		let temporaryHero
		let temporaryVillain

		const actionAbs = heroMainAbs.map((item, i) => item * action.played[i]) // hero abs
		const villainAbs = action.villain_range

		for (let i = 0; i < 1326; i++) {
			temporaryHero = actionAbs[i]
			temporaryVillain = villainAbs[i]

			const firstCard = handCards[i][0]
			const secondCard = handCards[i][1]

			let handName = ''

			if (firstCard < secondCard) {
				handName = cardToStr(secondCard) + cardToStr(firstCard)
			} else {
				handName = cardToStr(firstCard) + cardToStr(secondCard)
			}

			if (
				query.includes('_F.') &&
				(board.indexOf(handName.slice(0, 2)) > -1 || board.indexOf(handName.slice(2)) > -1)
			) {
				continue
			}

			if (temporaryHero > 0) {
				// for villain
				heroSum += temporaryHero
				cardsHero[firstCard] += temporaryHero
				cardsHero[secondCard] += temporaryHero
			}

			if (temporaryVillain > 0) {
				// for hero
				villainSum += temporaryVillain
				cardsVillain[firstCard] += temporaryVillain
				cardsVillain[secondCard] += temporaryVillain
			}
		}

		for (let i = 0; i < 1326; i++) {
			temporaryHero = actionAbs[i]
			temporaryVillain = villainAbs[i]

			const firstCard = handCards[i][0]
			const secondCard = handCards[i][1]

			let handName = ''

			if (firstCard < secondCard) {
				handName = cardToStr(secondCard) + cardToStr(firstCard)
			} else {
				handName = cardToStr(firstCard) + cardToStr(secondCard)
			}

			if (
				query.includes('_F.') &&
				(board.indexOf(handName.slice(0, 2)) > -1 || board.indexOf(handName.slice(2)) > -1)
			) {
				villainProb.push(0)
				heroProb.push(0)
			} else {
				heroProb.push(villainSum - cardsVillain[firstCard] - cardsVillain[secondCard] + temporaryVillain)
				villainProb.push(heroSum - cardsHero[firstCard] - cardsHero[secondCard] + temporaryHero)
			}
		}

		return { ...action, heroProb, villainProb }
	})
}

export const getRequestFilters = (
	crossFilters,
	configMode,
	multiEffStacks,
	heroPositions,
	heroActivePlayer,
	isTrainerInit
) => {
	let rightRequestFilters = null

	if (crossFilters) {
		rightRequestFilters = Object.entries(crossFilters)
			.map(([key, value]) => {
				if (value.includes('Any')) {
					return [key, null]
				}

				return [key, value]
			})
			.reduce((acc, current) => {
				if (current[0] === 'hero_positions' && isTrainerInit) {
					acc[current[0]] = [heroActivePlayer]

					return acc
				}

				acc[current[0]] = current[1]

				return acc
			}, {})
	}

	return configMode === 'preflop' || configMode === 'postflop'
		? rightRequestFilters
		: {
				stack: multiEffStacks.length === 0 ? null : multiEffStacks,
				hero_positions: isTrainerInit ? [heroActivePlayer] : heroPositions.length === 0 ? null : heroPositions,
				villain_positions: null,
				hero_action: null,
				hero_oop_ip: null,
				hero_preflop_action: null,
		  }
}

export const getRequestStreetFilters = (filters, street) => {
	return street === 'flop'
		? {
				...filters,
				card_ranks: {
					high_rank: filters.card_ranks.high_rank?.includes('Any') ? null : filters.card_ranks.high_rank,
					middle_rank: filters.card_ranks.middle_rank?.includes('Any') ? null : filters.card_ranks.middle_rank,
					low_rank: filters.card_ranks.low_rank?.includes('Any') ? null : filters.card_ranks.low_rank,
				},
				subset: !filters.subset || filters.subset?.includes('Any') ? null : filters.subset[0],
		  }
		: {
				...filters,
				card_ranks: {
					high_rank: filters.card_ranks.high_rank?.includes('Any') ? null : filters.card_ranks.high_rank,
				},
		  }
}

export const getMaxEqr = (data) => {
	if (!data) {
		return {
			maxEqr: 0,
		}
	}

	return {
		maxEqr: Math.max(...data) / 100,
	}
}
